import React from "react";

export function AuthLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen w-full bg-background text-foreground">
      <div className="mx-auto flex min-h-screen max-w-screen-sm flex-col items-center justify-center p-4">
        {children}
      </div>
    </div>
  );
}

export default AuthLayout;

